<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-16 17:28:39
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-17 10:43:01
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\SystemSettings\LabelManage\components\addLabel.vue
-->
<template>
  <div>
    <!-- 新增编辑标签 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :close-on-click-modal='false'>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="标签名称:" prop='name'>
          <el-input v-model="form.name" maxlength="20" placeholder="请输入标签名称" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="归属大类:" prop='parentId'>
          <el-select v-model="form.parentId" placeholder="请选择归属大类" style="width:90%" @change="leftInfoChange"
            :disabled="title == '新增标签'?false:true">
            <el-option v-for="(item,index) in leftInfo" :key="index" :label="item.type" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="margin-top:20px">
          <el-button style="width:110px;height:32px" @click="resetClick">重置</el-button>
          <el-button style="width:110px;height:32px" type="primary" v-if="title == '新增标签'"
            @click="addLabel">确认</el-button>
          <el-button style="width:110px;height:32px" type="primary" v-if="title == '编辑标签'"
            @click="editLabel">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiLabel_leftData,
  apiLabel_leftData_new,
  apiLabel_Edit,
  apiLabelDown_Add
} from "../api/index";
export default {
  data() {
    return {
      title: "新增标签",
      dialogVisible: false,
      form: {},
      leftInfo: [],
      rules: {
        name: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
        parentId: [
          { required: true, message: "请选择归属大类", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    //打开弹窗
    openDialog() {
      this.title = "新增标签";
      this.form = {};
      this.dialogVisible = true;
      this.leftData();
      setTimeout(() => {
        this.$refs["form"].clearValidate("name");
        this.$refs["form"].clearValidate("parentId");
      }, 100);
    },
    //编辑打开弹窗
    editDialog(item) {
      this.leftData();
      this.dialogVisible = true;
      this.title = "编辑标签";
      this.form = { ...item };
      if (this.form.name) {
        setTimeout(() => {
          this.$refs["form"].clearValidate("name");
        }, 100);
      }
      if (this.form.parentId) {
        setTimeout(() => {
          this.$refs["form"].clearValidate("parentId");
        }, 100);
      }
    },
    //获取下拉框数据
    leftData() {
      apiLabel_leftData_new({
        parentId: 0,
        syncSource:"DSICM"
      }).then(res => {
        this.leftInfo = res.data;
      });
    },
    //新建保存
    addLabel() {
      this.$refs.form.validate(valid => {
        if (valid) {
          apiLabelDown_Add({ ...this.form }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.dialogVisible = false;
              this.$parent.leftData();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑保存
    editLabel() {
      this.$refs.form.validate(valid => {
        if (valid) {
          apiLabel_Edit({ ...this.form }).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.dialogVisible = false;
              this.$parent.rightData();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    leftInfoChange(e) {
      let arr = this.leftInfo.filter(item => {
        return item.id == e;
      });
      this.form.type = arr[0].type;
    },
    resetClick() {
      if (this.title == "新增标签") {
        this.form.name = "";
        this.form.parentId = "";
      } else {
        this.form.name = "";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 18px;
  font-weight: bolder;
  color: #000;
  text-align: center;
  margin-bottom: 30px;
}
</style>